import { injectReducer } from './index';
import React, { FC } from 'react';

interface ComponentProps {}

const withReducer = (key: string, reducer: any) => (WrappedComponent: FC<ComponentProps>) => {
	injectReducer(key, reducer);

	return (props: ComponentProps) => <WrappedComponent {...props} />;
};

export default withReducer;
